<section class="head">
	<ng-content select="[slot='start']"/>

	<a class="logo" [routerLink]="dashboardUrl | sklCompanyLink">
		<i class="icon-subiekt123"></i>
	</a>
</section>

<section
	class="title"
	[tooltip]="companyName()"
	[tooltipContainerRef]="compoanyName"
>
	<h1 #compoanyName>{{ companyName() }}</h1>
</section>

<section class="user-panel">
	<skl-ksef-configuration-state-button id="app-bar-ksef-configuration-button"/>

	<skl-announcements-button
		id="app-bar-notification-button"
		class="app-bar-button" />

	<button
		id="app-bar-configuration-button"
		class="app-bar-button"
		(click)="goTo('configuration')"
	>
		<ins-icon name="settings-filled" size="30px" />
	</button>

	<skl-insert-user-panel>
		<div class="user-panel-group">
			<div id="iup-account-default-ki-btn"></div>

			<div class="user-panel-item" (click)="goTo('help')">
				<ins-icon name="info-ki" size="24px" />
				<span>{{ 'app-bar.help-menu.e-help' | translate }}</span>
			</div>

			<div class="user-panel-item" (click)="goTo('forum')">
				<ins-icon name="forum" size="24px" />
				<span>{{ 'app-bar.help-menu.users-forum' | translate }}</span>
			</div>
		</div>

		<div class="user-panel-group">
			<div id="iup-account-default-theme-btn"></div>

			<skl-language-picker-ki
				[language]="language()!"
				[languages]="languages"
				(languageChange)="changeLanguage($event)"
			/>

			<div class="user-panel-item" (click)="goTo('configuration')">
				<ins-icon name="config" size="24px" />
				<span>{{ 'app-bar.configuration.label' | translate }}</span>
			</div>
		</div>

		<div class="user-panel-group">
			<div id="iup-account-default-logout-btn"></div>
		</div>

	</skl-insert-user-panel>
</section>
